module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j3Rtk"))).then(() => parcelRequire('d0iPb'));